import { isToday, parseISO } from "date-fns";

export const isDateToday = (date: Date) => isToday(parseISO(`${date}`));
